




















































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { getCost, isCryptoSystem } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import getComponent, { getCryptoButtons } from "./integrations";

export default defineComponent({
  name: "ChoosePaymentSystem",
  components: { ModalView, PageTitle, BaseButton, BaseIcon, FormatMoney },
  props: {
    processing: { type: Boolean, default: false },
    subjectId: { type: String, required: true },
    subjectType: { type: String as PropType<ContentPriceSubjectTypeEnum>, required: true },
    pricePackageId: { type: String, required: true },
    paymentSystemsPublic: { type: Array as () => PaymentSystemPublic[], required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
  },
  setup(props) {
    const selectedCryptoSystem = ref("");
    const cryptoPaymentSystems = computed(() =>
      props.paymentSystemsPublic.filter(system => isCryptoSystem(system.type))
    );
    const cryptoButtons = computed(() =>
      getCryptoButtons().filter(
        i => !!cryptoPaymentSystems.value.find(s => s.type === i.name && s.currencies.length > 0)
      )
    );
    const cardPaymentSystems = computed(() =>
      props.paymentSystemsPublic.filter(system => !isCryptoSystem(system.type))
    );
    const cryptoForm = computed(() => getComponent(selectedCryptoSystem.value).component);
    const cryptoPageTitle = computed(() => getComponent(selectedCryptoSystem.value).cryptoPageTitle);
    const handleButtonClick = (systemName: string) => {
      selectedCryptoSystem.value = systemName;
    };
    const oneTimeCost = computed(() => {
      if (props.pricePackageId === "0") return 0;
      const paymentPackage = props.paymentPackages.find(item => item.id === props.pricePackageId);
      if (!paymentPackage) return 0;
      return getCost(paymentPackage);
    });

    return {
      oneTimeCost,
      selectedCryptoSystem,
      cryptoButtons,
      cryptoPageTitle,
      cardPaymentSystems,
      cryptoForm,
      handleButtonClick,
    };
  },
});
